import { IconKsiezyc, IconSlonce } from "../icons/index.js";
import { useTheme } from "../../theme/useTheme.js";

/**
 * B-9: przelacznik motywu slonce-ksiezyc, zawsze w widocznej kontrolce (B-7), nie gola ikona.
 *
 * Obie ikony leza na sobie i krzyzuja sie w miejscu - stad `position: absolute` w CSS.
 * Ktora jest widoczna, decyduje `[data-theme]` na <html>, nie React: dzieki temu
 * przelaczenie jest natychmiastowe, bez czekania na render.
 */

interface Props {
  /** "pasek" to kontrolka headera (B-7), "menu" to pozycja w menu profilu (telefon). */
  wariant: "pasek" | "menu";
}

export function ThemeToggle({ wariant }: Props): React.JSX.Element {
  const { przelacz } = useTheme();

  if (wariant === "menu") {
    return (
      <button type="button" className="acct-menu__item menu-theme" role="menuitem" onClick={przelacz}>
        <span className="theme-ic" aria-hidden="true">
          <IconSlonce className="ic-sun" />
          <IconKsiezyc className="ic-moon" />
        </span>
        Zmień motyw
      </button>
    );
  }

  return (
    <button
      type="button"
      className="hbtn hbtn--icon bar-theme"
      onClick={przelacz}
      aria-label="Przełącz motyw jasny i ciemny"
    >
      <IconSlonce className="ic-sun" />
      <IconKsiezyc className="ic-moon" />
    </button>
  );
}
